import { Component, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-accept-cookie',
  templateUrl: './accept-cookie.component.html',
})

export class AcceptCookieComponent {

  @Output() onAgree = new EventEmitter();
  @Output() onDisagree = new EventEmitter();

  @ViewChild('confirmButton', {​​​​​static: true}) confirmButton: ElementRef;
  @ViewChild('cancelButton', {​​​​​static: true}) cancelButton: ElementRef;

  onClick(confirmed: boolean): void {
    if (confirmed == true) {
      if (!this.isNull(this.onAgree)) this.onAgree.emit();
    } else {
      if (!this.isNull(this.onDisagree)) this.onDisagree.emit();
    }
  }

  isNull(value){
    if (typeof value == 'undefined' || value == null) return true; else return false;
  }
}
